import { request } from "#/utils/request";

export interface IGetVendasContrato {
  codigoComissionado: string;
  idDocumento: number;
  conta: string;
  cooperativa: string;
  documento: string;
}

export interface IGetVendasContratoData {
  data: Data;
  errors: Errors;
}

interface Data {
  contract: string;
}

interface Errors {
  message: string;
  code: number;
}

export const getVendasContrato = async ({
  codigoComissionado,
  idDocumento,
  conta,
  cooperativa,
  documento,
}: IGetVendasContrato) =>
  (
    await request.post<IGetVendasContratoData>(
      `/vendas/contrato?codigoComissionado=${codigoComissionado}&idDocumento=${idDocumento}&conta=${conta}&cooperativa=${cooperativa}&documento=${documento}`,
      {}
    )
  ).data;
